import React, { Component } from 'react';
import FetchCall, { partnerApi } from  './../../../../API/FetchCall';

import SimpleReactValidator from 'simple-react-validator';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class Password_pro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 1,
      password: '',
      confirm_password: '',
    }
    this.validator = new SimpleReactValidator({
      validators: {
        password_custome: {  // name the rule
          message: 'The :attribute must be a Min of 8 characters in length – One Capital Letter, One Number, One Character.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        confirmpassword: {  // name the rule
          message: 'The :attribute must be Same as Password.',
          rule: (val, params, validator) => {
            if (val != this.state.password) {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        }
      }
    });
  }


  componentDidMount() {
    if (this.state.authentication == true) {
      this.setState({
        user_type: this.state.user_data.user_type
      });
    }
  }
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    this.validator.purgeFields();
    return (
      <React.Fragment>

        <div class="category_block">
          <div class="titleline">
            <h4>Password</h4>
          </div>
          <form onSubmit={this.submitForm}>
            <div class="box-shadow-custom">
              <div className='row'>
                <div class="form-group col-md-4">
                  <label>Enter Old Password <span class="astrick">*</span></label>
                  <input type="password"
                    class="form-control" name="old_password"
                    value={this.state.old_password}
                    onChange={this.handleChange} />
                  {this.validator.message('Old Password', this.state.old_password, 'required', { className: 'text-danger' })}
                </div>
                <div class="form-group col-md-4">
                  <label>Enter New Password <span class="astrick">*</span></label>
                  <input type="password"
                    class="form-control" name="password"
                    value={this.state.password}
                    onChange={this.handleChange} />
                  {this.validator.message('Password', this.state.password, 'required|password_custome', { className: 'text-danger' })}
                </div>
                <div class="form-group col-md-4">
                  <label>Re-type New Password <span class="astrick">*</span></label>
                  <input type="password"
                    class="form-control" name="confirm_password"
                    value={this.state.confirm_password}
                    onChange={this.handleChange} />
                  {this.validator.message('Confirm Password', this.state.confirm_password, 'required|confirmpassword', { className: 'text-danger' })}
                </div>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
              <button type='submit' id="btnSubmit"
                className="btn btn-primary btn-sm">
                Save
              </button>
            </div>
          </form>
        </div>     
        <NotificationContainer/>    
      </React.Fragment>

    );
  }
  submitForm = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const { user_type, partner_id, is_completd } = this.state.user_data;
      let request = JSON.stringify({
        user_type: user_type,
        login_id: partner_id,
        password: this.state.password,
        url: 'updatePassword'
      });
      partnerApi(request).then(res => {
        //let toastr = '';
        if (res.status === 1) {
          /*
          toastr = window.toastr.success;
          */
          this.setState({
            password: '',
            confirm_password: '',
            old_password:''
          });
          NotificationManager.success(res.message);
          
        } else {
          NotificationManager.error(res.message);
          //toastr = window.toastr.error;
        }

        /*
        toastr(res.message, {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        */
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
}

export default Password_pro;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/update_profile/password_profile.jsx